import { render, staticRenderFns } from "./ListaConversasBase.vue?vue&type=template&id=93ada43a&scoped=true"
import script from "./ListaConversasBase.vue?vue&type=script&lang=js"
export * from "./ListaConversasBase.vue?vue&type=script&lang=js"
import style0 from "../styles/conversas-shared.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ListaConversasBase.vue?vue&type=style&index=1&id=93ada43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ada43a",
  null
  
)

export default component.exports